import React, { useState, useEffect, useRef, Fragment } from "react";
import { useReactToPrint } from 'react-to-print';
import { Col, Container, Row, Card, Stack, Image, Table } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { Divider, Button, Icon, Dimmer, Loader } from "semantic-ui-react";
import axios from "axios";
import Barcode from "react-barcode";
import logo from '../../assets/rudrunner_logo.png'

const OrderInvoice = () => {
    const location = useLocation()
    const componentRef = useRef();
    const [idOrder, setIdOrder] = useState(null)
    const [idCustomer, setIdCustomer] = useState(null)
    const [order, setOrder] = useState(null)
    const [isLoadingType, setIsLoadingType] = useState(true)
    const [isPickUp, setIsPickUp] = useState(false)
    const [pickUpWarehouse, setPickUpWarehouse] = useState(null)
    const [warehouseDetailData, setWarehouseDetailData] = useState({})
    const [warehouseDetailLoader, setWarehouseDetailLoader] = useState(true)
    const [resiData, setResiData] = useState({})
    const [hasWarehouse, setHasWarehouse] = useState(true)
    const [resiDataLoader, setResiDataLoader] = useState(true)
    const [totalItem, setTotalItem] = useState(0)

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const capitalizeWords = (str) => {
        return str
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    const getResi = async (id_order) => {
        setResiDataLoader(true)
        await axios({
            method: "GET",
            url: `${global.SRV}api_rudrunner_cms/controler/order.php/?index=13&id_order=${id_order}`,
            headers: { 'Content-Type': 'text/plain' },
        })
            .then(res => {
                console.log(res.data.data)
                if (res.data.state === 200) {
                    setResiData(res.data.data)
                }
                console.log(res.data.data)
                setResiDataLoader(false)
            })
    }

    const getOrderType = async (id_order) => {
        setIsLoadingType(true)
        await axios({
            method: "GET",
            url: `${global.SRV}api_rudrunner_cms/controler/order.php/?index=16&id_order=${id_order}`,
            headers: { 'Content-Type': 'text/plain' },
        })
            .then(res => {
                setIsLoadingType(false)
                let data = res.data
                if (data.state === 200) {
                    console.log(data)
                    if (data.data !== '0') {
                        setIsPickUp(true)
                        setPickUpWarehouse(data.data)
                    } else {
                        setIsPickUp(false)
                    }
                }
            })
            .catch((error) => {
                console.log(error)
                setIsLoadingType(false)
            })
    }

    const getWarehouseDetail = async () => {
        await axios({
            method: "POST",
            // url: `${global.SRV}api_rudrunner/controler/cart.php/?index=22`,
            url: `${global.hoops_api}api_rudrunner/controler/cart.php/?index=22`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': '9c98dh92db9ejn'
            },
        })
            .then((response) => {
                if (response.data.state == 200) {
                    let data = response.data.data
                    console.log(data)
                    setWarehouseDetailData(data)
                }
                setWarehouseDetailLoader(false)
            })
            .catch((error) => {
                console.log(error)
                setWarehouseDetailLoader(false)
            })
    }

    useEffect(() => {
        getWarehouseDetail()
    }, []);

    const getOrder = async (id_order, id_customer) => {
        const param = {
            id_order: id_order,
            id_customer: id_customer,
        }
        axios({
            method: "POST",
            url: `${global.SRV}api_rudrunner_cms/controler/order.php/?index=3`,
            headers: { 'Content-Type': 'text/plain' },
            data: param
        })
            .then(res => {
                if (res.data.state === 200) {
                    setOrder(res.data.data)
                    let total = 0;
                    let data = res.data.data.detail
                    for (let index = 0; index < data.length; index++) {
                        const element = data[index];
                        total += parseInt(element.qty);
                    }
                    setTotalItem(total)
                    const hasNullWarehouse = res.data.data.detail.some(item => item.id_warehouse === null);
                    if (hasNullWarehouse) {
                        setHasWarehouse(false)
                    } else {
                        setHasWarehouse(true)
                    }
                }
            })
    }

    const PrintComponent = React.forwardRef((props, ref) => {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        let orderDate = new Date(order.header.order_date)
        let dateFormated = orderDate.toLocaleDateString("en-US", options)
        let orderID = order.header.id_order
        let invNumber = `INV${orderID.slice(2, orderID.length)}`

        return (
            <Fragment>
                <div ref={ref} style={{ paddingTop: 50 }}>
                    <div
                        style={{
                            position: 'absolute',
                            top: '28%',
                            left: '23%',
                            zIndex: 'auto',
                            letterSpacing: '40px',
                            transform: "rotate(-35deg)",
                            opacity: '0.1',
                            // fontSize:'7em',
                            fontSize: '5em',
                            fontWeight: 'bold',
                        }}
                    >{(order.payment.payment_status == 'settlement' || order.payment.payment_status == 'capture') ? "PAID" : "UNPAID"}</div>
                    <Row className="d-flex justify-content-center">
                        <Col sm={10}>
                            <Stack direction="horizontal" gap={2}>
                                <Image src={logo} width={70} height={50} />
                                <div>
                                    <div className="fw-bold">HOOPS INDONESIA</div>
                                    <div style={{ fontSize: '0.7nm' }}>The Biggest Basketball Store in Indonesia.</div>
                                </div>
                            </Stack>
                        </Col>
                    </Row>
                    <Row className="d-flex justify-content-center">
                        <Col sm={10}><Divider /></Col>
                    </Row>
                    <Row className="d-flex justify-content-center mb-3">
                        <Col sm={10} className="d-flex justify-content-end fw-bold text-facebook">INVOICE&nbsp;&nbsp;#{invNumber}</Col>
                        <Col sm={10} className="d-flex justify-content-start mb-3" >
                            <Row className="">
                                <Col sm={3} className="text-muted">Name</Col>
                                <Col sm={8} className="fw-bold">:&nbsp;{order.customer.first_name + ' ' + order.customer.last_name}</Col>
                                <Col sm={3} className="text-muted">Order Date</Col>
                                <Col sm={8} className="fw-bold">:&nbsp;{dateFormated}</Col>
                                <Col sm={3} className="text-muted">Order Type</Col>
                                <Col sm={8} className="fw-bold">:
                                    {!isPickUp ? ' Delivery Order' : ' Pick Up Order'}
                                </Col>
                                {!isPickUp ?
                                    <>
                                        <Col sm={3} className="text-muted">Shipping Address</Col>
                                        <Col sm={8}>
                                            <div><span className="fw-bold">:&nbsp;{order.header.recipient}</span> ({order.header.phone})</div>
                                            <div>&nbsp;&nbsp;{order.header.address_detail}&nbsp;{order.header.address_detail_dua}</div>
                                            <div>&nbsp;&nbsp;{order.header.sub_district}, {order.header.district}, {order.header.city}, {order.header.zip}</div>
                                            <div>&nbsp;&nbsp;{order.header.province}</div>
                                        </Col>
                                    </>
                                    :
                                    <>
                                        <Col sm={3} className="text-muted">Warehouse Detail</Col>
                                        <Col sm={8}>
                                            <div><span className="fw-bold">:&nbsp;{warehouseDetailData && warehouseDetailData[pickUpWarehouse]?.name}</span> &nbsp;
                                                ({warehouseDetailData && warehouseDetailData[pickUpWarehouse]?.phone})
                                            </div>
                                            <div>&nbsp;&nbsp;{warehouseDetailData && warehouseDetailData[pickUpWarehouse]?.address}</div>
                                            <div>&nbsp;&nbsp;{warehouseDetailData && warehouseDetailData[pickUpWarehouse]?.city}, {warehouseDetailData && warehouseDetailData[pickUpWarehouse]?.zip_code}</div>
                                            <div>&nbsp;&nbsp;{warehouseDetailData && warehouseDetailData[pickUpWarehouse]?.prov}</div>
                                        </Col>
                                    </>
                                }
                            </Row>
                        </Col>
                        <Col sm={10} className="mb-3">
                            {!hasWarehouse && !isPickUp ?
                                <Table>
                                    <thead>
                                        <tr className="text-facebook">
                                            <th>#</th>
                                            <th>PRODUCT</th>
                                            <th>DISCOUNT</th>
                                            <th>MULTIPLE DISC</th>
                                            <th>QTY</th>
                                            <th>BASE PRICE</th>
                                            <th>TOTAL PRICE</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            order?.detail?.map((o, i) => {
                                                return (
                                                    <tr key={i}>
                                                        <td>{i + 1}</td>
                                                        <td>

                                                            <Stack direction="horizontal" gap={3}>
                                                                <Image src={o.image} width={58} height={48} rounded />
                                                                <Stack direction="vertical" gap={0}>
                                                                    <div className="fw-bold">{o.product_detail?.product_name}</div>
                                                                    <div>{o.product_detail?.id_product}</div>
                                                                    <div>
                                                                        <span className="me-3">Size: {o.size}</span>
                                                                        <span>Weight: {o.product_detail?.weight} Kg</span>
                                                                    </div>
                                                                </Stack>
                                                            </Stack>
                                                        </td>
                                                        <td>
                                                            <div>{parseInt(o.discount) > 0 && parseInt(o.discount) <= 100 ? `${o.discount}%` : parseInt(o.discount) > 0 && parseInt(o.discount) > 100 ? `${global.IDR.format(o.discount)}` : parseInt(o.flashsale_discount) > 0 && parseInt(o.flashsale_discount) <= 100 ? `${o.flashsale_discount}%` : parseInt(o.flashsale_discount) > 0 && parseInt(o.flashsale_discount) > 100 ? `${global.IDR.format(o.flashsale_discount)}` : '0'}</div>
                                                            <div className="text-nowrap text-truncate" style={{ color: 'coral', fontSize: '0.8em', fontWeight: 'bold', width: 120 }}>{parseInt(o.flashsale_discount) > 0 ? <><Icon name="tag" />{o.flashsale_name}</> : ''}</div>
                                                        </td>
                                                        <td>
                                                            {o.multiple_disc_label !== null ? o.multiple_disc_label : ""}
                                                        </td>
                                                        <td>
                                                            <b className="text-danger">
                                                                {o.qty}
                                                            </b>
                                                        </td>
                                                        <td className="text-center">
                                                            {
                                                                o.multiple_disc_label !== "" ? (
                                                                    <>
                                                                        <div>{global.IDR.format(o.total_price)} </div>
                                                                        <div className="text-muted"><s>{global.IDR.format(o.price)}</s></div>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <div>{parseInt(o.discount) > 0 && parseInt(o.discount) <= 100 ? global.IDR.format(o.price - parseFloat(o.price) * parseInt(o.discount) / 100) : parseInt(o.discount) > 0 && parseInt(o.discount) > 100 ? global.IDR.format(o.price - parseInt(o.discount)) : global.IDR.format(o.price)} </div>
                                                                        {
                                                                            parseInt(o.discount) > 0 ?
                                                                                <div className="text-muted"><s>{global.IDR.format(o.price)}</s></div>
                                                                                : <></>
                                                                        }
                                                                    </>
                                                                )
                                                            }
                                                        </td>
                                                        {/* <td className="text-center">{global.IDR.format(o.total_price)}</td> */}
                                                        <td className="text-center">
                                                            {global.IDR.format(
                                                                (
                                                                    o.multiple_disc_label !== "" ?
                                                                        o.total_price
                                                                        :
                                                                        Number(o.price) -
                                                                        (
                                                                            o.discount > 0 && o.discount <= 100
                                                                                ? Number(o.price) * Number(o.discount) / 100
                                                                                : o.discount > 100
                                                                                    ? Number(o.discount)
                                                                                    : 0
                                                                        )
                                                                ) * Number(o.qty)
                                                            )}
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </Table>
                                :
                                <Table>
                                    <thead>
                                        <tr className="text-facebook text-center">
                                            <th>#</th>
                                            <th>PRODUCT</th>
                                            <th>DISCOUNT</th>
                                            <th>MULTIPLE DISC</th>
                                            <th>QTY</th>
                                            <th>BASE PRICE</th>
                                            <th>TOTAL PRICE</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            Object.entries(
                                                order?.detail.reduce((acc, o) => {
                                                    if (!acc[o.id_warehouse]) acc[o.id_warehouse] = [];
                                                    acc[o.id_warehouse].push(o);
                                                    return acc;
                                                }, {})
                                            )
                                                .sort(([a], [b]) => {
                                                    if (a === 'WH0001') return -1;
                                                    if (b === 'WH0001') return 1;
                                                    return a.localeCompare(b);
                                                })
                                                .map(([warehouseId, items], warehouseIndex) => (
                                                    <React.Fragment key={warehouseId}>
                                                        {/* Warehouse Header Row */}
                                                        <tr>
                                                            <td colSpan="7" className="fw-bold text-center" style={{ backgroundColor: '#f2f2f2' }}>
                                                                {/* {warehouseDetailData[warehouseId]?.name}, {capitalizeWords(warehouseDetailData[warehouseId]?.city)} */}
                                                                {warehouseDetailData[warehouseId]?.name}, {warehouseDetailData[warehouseId]?.city}
                                                            </td>
                                                        </tr>
                                                        {/* Product Rows */}
                                                        {items.map((o, i) => (
                                                            <tr key={warehouseIndex + '-' + i}>
                                                                <td className="text-center">{i + 1}</td>
                                                                <td>
                                                                    <Stack direction="horizontal" gap={3}>
                                                                        <Image src={o.image} width={58} height={48} rounded />
                                                                        <Stack direction="vertical" gap={0}>
                                                                            <div className="fw-bold">{o.product_detail?.product_name}</div>
                                                                            <div>{o.product_detail?.id_product}</div>
                                                                            <div>
                                                                                <span className="me-3">Size: {o.size}</span>
                                                                                <span>Weight: {o.product_detail?.weight} Kg</span>
                                                                            </div>
                                                                        </Stack>
                                                                    </Stack>
                                                                </td>
                                                                <td className="text-center">
                                                                    <div>{parseInt(o.discount) > 0 && parseInt(o.discount) <= 100 ? `${o.discount}%` : parseInt(o.discount) > 0 && parseInt(o.discount) > 100 ? `${global.IDR.format(o.discount)}` : parseInt(o.flashsale_discount) > 0 && parseInt(o.flashsale_discount) <= 100 ? `${o.flashsale_discount}%` : parseInt(o.flashsale_discount) > 0 && parseInt(o.flashsale_discount) > 100 ? `${global.IDR.format(o.flashsale_discount)}` : '0'}</div>
                                                                    <div className="text-nowrap text-truncate" style={{ color: 'coral', fontSize: '0.8em', fontWeight: 'bold', width: 120 }}>
                                                                        {parseInt(o.flashsale_discount) > 0 ? <><Icon name="tag" />{o.flashsale_name}</> : ''}
                                                                    </div>
                                                                </td>
                                                                <td className="text-center">
                                                                    {o.multiple_disc_label !== null ? o.multiple_disc_label : ""}
                                                                </td>
                                                                <td className="text-center">
                                                                    <b className={o.qty > 1 ? "text-danger" : "text-primary"}>
                                                                        {o.qty}
                                                                    </b>
                                                                </td>
                                                                <td className="text-center">
                                                                    {
                                                                        o.multiple_disc_label !== "" ? (
                                                                            <>
                                                                                <div>{global.IDR.format(o.total_price)} </div>
                                                                                <div className="text-muted"><s>{global.IDR.format(o.price)}</s></div>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <div>{parseInt(o.discount) > 0 && parseInt(o.discount) <= 100 ? global.IDR.format(o.price - parseFloat(o.price) * parseInt(o.discount) / 100) : parseInt(o.discount) > 0 && parseInt(o.discount) > 100 ? global.IDR.format(o.price - parseInt(o.discount)) : global.IDR.format(o.price)} </div>
                                                                                {
                                                                                    parseInt(o.discount) > 0 ?
                                                                                        <div className="text-muted"><s>{global.IDR.format(o.price)}</s></div>
                                                                                        : <></>
                                                                                }
                                                                            </>
                                                                        )
                                                                    }
                                                                </td>
                                                                {/* <td className="text-center">{global.IDR.format(o.total_price)}</td> */}
                                                                <td className="text-center">
                                                                    {global.IDR.format(
                                                                        (
                                                                            o.multiple_disc_label !== "" ?
                                                                                o.total_price
                                                                                :
                                                                                Number(o.price) -
                                                                                (
                                                                                    o.discount > 0 && o.discount <= 100
                                                                                        ? Number(o.price) * Number(o.discount) / 100
                                                                                        : o.discount > 100
                                                                                            ? Number(o.discount)
                                                                                            : 0
                                                                                )
                                                                        ) * Number(o.qty)
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </React.Fragment>
                                                ))
                                        }
                                    </tbody>
                                </Table>
                            }
                        </Col>
                        <Col sm={!isPickUp ? "6" : "10"}>
                            <Stack direction="horizontal" gap={1} className="mb-2">
                                <div style={{ width: '35%' }} className="fw-bold">TOTAL PRICE ({totalItem} ITEM)</div>
                                <div className="fw-bold">:&nbsp;{global.IDR.format(order.header.total_price)}</div>
                            </Stack>
                            {hasWarehouse && !isPickUp && (
                                <>
                                    <Stack className="text-secondary" direction="horizontal" gap={1}>
                                        <div style={{ width: '35%' }}>Shipping Detail</div>
                                        {/* <div>:&nbsp;{global.IDR.format(order.header.asuransi)}</div> */}
                                    </Stack>
                                    <table className="table table-borderless text-secondary table-stripped">
                                        <tr>
                                            <td>
                                                WH
                                            </td>
                                            <td>
                                                Courier
                                            </td>
                                            <td>
                                                Shipping Cost
                                            </td>
                                            <td>
                                                Shipping Insurance
                                            </td>
                                            <td>
                                                Total Weight
                                            </td>
                                        </tr>
                                        {
                                            Object.entries(
                                                resiData?.reduce((acc, item) => {
                                                    const key = item.id_warehouse;
                                                    if (!acc[key]) acc[key] = [];
                                                    acc[key].push(item);
                                                    return acc;
                                                }, {})
                                            )
                                                .sort(([a], [b]) => {
                                                    if (a === 'WH0001') return -1;
                                                    if (b === 'WH0001') return 1;
                                                    return a.localeCompare(b);
                                                })
                                                .map(([warehouseId, items], groupIndex) => {
                                                    const item = items[0]
                                                    return (
                                                        <>
                                                            <tr>
                                                                <td>
                                                                    {warehouseDetailData[warehouseId]?.alias}
                                                                </td>
                                                                <td>
                                                                    {`${item.courier_name} (${item.service_display})`}
                                                                </td>
                                                                <td className="text-justify">
                                                                    {global.IDR.format(item.shipping_cost)}
                                                                </td>
                                                                <td className="text-justify">
                                                                    {global.IDR.format(item.shipping_insurance)}
                                                                </td>
                                                                <td>
                                                                    {item.weight} KG
                                                                </td>
                                                            </tr>
                                                        </>
                                                    )
                                                })
                                        }
                                    </table>
                                </>)}
                            {!isPickUp ?
                                <>
                                    <Stack direction="horizontal" gap={1}>
                                        <div style={{ width: '35%' }}>Total Shipping Cost ({order.header.total_weight} KG)</div>
                                        <div>
                                            :&nbsp;{global.IDR.format(order.header.courier_cost)}&nbsp;
                                            ({global.IDR.format(parseFloat(order.header.courier_cost) + parseFloat(order.header.shipping_voucher))}) &nbsp;
                                            {!hasWarehouse && (
                                                <span className="text-muted fw-bold">{order.header.name} - {order.header.service_display}</span>
                                            )}
                                        </div>
                                    </Stack>
                                    <Stack direction="horizontal" gap={1}>
                                        <div style={{ width: '35%' }}>Total Shipping Insurance</div>
                                        <div>:&nbsp;{global.IDR.format(order.header.asuransi)}</div>
                                    </Stack>
                                    <Stack direction="horizontal" gap={1}>
                                        <div style={{ width: '35%' }}>Total Shipping Disc.</div>
                                        <div>:&nbsp;{global.IDR.format(order.header.shipping_voucher)}</div>
                                    </Stack>
                                </> : <></>
                            }
                            <Stack direction="horizontal" gap={1}>
                                <div style={{ width: '35%' }}>Total Voucher</div>
                                <div style={{ color: 'coral', fontWeight: 'bold' }}>:&nbsp;{global.IDR.format(order.header.total_voucher)}</div>
                            </Stack>
                            <Stack direction="horizontal" gap={1} className="mb-2 mt-2">
                                <div style={{ width: '35%' }} className="fw-bold">TOTAL INVOICE</div>
                                <div className="fw-bold">:&nbsp;{global.IDR.format(order.header.total_payment)}</div>
                            </Stack>
                        </Col>
                        {!isPickUp ?
                            <>
                                <Col sm={4}>
                                    <div className="fw-bold mb-2">COURIER:</div>
                                    {!hasWarehouse && (
                                        <Stack direction="horizontal" gap={2} className="mb-3">
                                            <div className="text-start" style={{ border: 'solid 1px lightgrey', padding: '2px' }}><Image src={order.header.logo} height={40} width={40} /></div>
                                            <Stack direction="vertical" gap={0}>
                                                <div className="fw-bold">{order.header.name}</div>
                                                <div className="text-facebook fw-bold">Service type: {order.header.service_display}</div>
                                            </Stack>
                                        </Stack>
                                    )}
                                    <Stack direction="vertical" gap={2} className="mb-3">
                                        {hasWarehouse && Object.entries(
                                            resiData?.reduce((acc, item) => {
                                                const key = `${item.courier_name}-${item.service_display}`;
                                                if (!acc[key]) acc[key] = { courier_name: item.courier_name, service_display: item.service_display, items: [] };
                                                acc[key].items.push(item);
                                                return acc;
                                            }, {})
                                        )
                                            .sort(([a], [b]) => {
                                                if (a.includes('WH0001')) return -1;
                                                if (b.includes('WH0001')) return 1;
                                                return a.localeCompare(b);
                                            })
                                            .map(([groupKey, groupData], groupIndex) => {
                                                const firstItem = groupData.items[0];
                                                return (
                                                    <React.Fragment key={groupKey}>
                                                        <Stack direction="horizontal" gap={2}>
                                                            <div className="text-center w-25" style={{ border: 'solid 1px lightgrey', padding: '2px' }}>
                                                                <Image src={order.header.logo} height={40} width={40} />
                                                            </div>
                                                            <div className="fw-bold">{firstItem?.courier_name}</div>
                                                            <div className="text-facebook fw-bold">Service type: {firstItem?.service_display}</div>
                                                            <div style={{ fontSize: '0.8em', color: 'grey' }}>
                                                                ({groupData.items.map(i => warehouseDetailData[i.id_warehouse]?.alias).join(', ')})
                                                            </div>
                                                        </Stack>
                                                    </React.Fragment>
                                                );
                                            })
                                        }
                                    </Stack>

                                    <div className="fw-bold">NO RESI:</div>
                                    {!hasWarehouse && (
                                        <div className="fw-bold text-facebook">
                                            {order.header.no_resi}
                                        </div>
                                    )}
                                    {
                                        // order.header.no_resi ?
                                        // <Barcode height={40} value={order.header.no_resi}/>
                                        // : <p className="text-muted">Not yet available</p>
                                    }
                                    {hasWarehouse && Object.entries(
                                        resiData.reduce((acc, item) => {
                                            const key = item.id_warehouse;
                                            if (!acc[key]) acc[key] = [];
                                            acc[key].push(item);
                                            return acc;
                                        }, {})
                                    )
                                        .sort(([a], [b]) => {
                                            if (a === 'WH0001') return -1;
                                            if (b === 'WH0001') return 1;
                                            return a.localeCompare(b);
                                        })
                                        .map(([warehouseId, items], groupIndex) => {
                                            const item = items[0]
                                            return (
                                                <>
                                                    <h6>
                                                        {`${item.no_resi ? item.no_resi : 'Undefined Resi Number'} (${warehouseDetailData[warehouseId]?.alias})`}
                                                    </h6>
                                                </>
                                            )
                                        })
                                    }
                                </Col>
                            </>
                            :
                            <></>
                        }
                        <Col sm={10}>
                            <div style={{ width: '25%' }}>Payment Method</div>
                            <div className="fw-bold text-uppercase">{order.payment.payment_method} - {order.payment.bank}</div>
                        </Col>
                    </Row>
                    <Row className="d-flex justify-content-center mt-5 mb-3">
                        <Col sm={6} style={{ width: '84%' }}>
                            <Row>
                                <Col sm={6} style={{ fontSize: "small" }}>This invoice is valid and processed by a digital system</Col>
                                <Col sm={6} className="d-flex justify-content-end" style={{ fontSize: "small" }}><i>Last update : {order.header.date_update} WIB</i></Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </Fragment>
        )
    })

    useEffect(() => {
        setIdOrder(location.state.id_order)
        getOrderType(location.state.id_order)
        setIdCustomer(location.state.id_customer)
        getOrder(location.state.id_order, location.state.id_customer)
        getResi(location.state.id_order)
    }, [location.state])

    // useEffect()

    return (
        isLoadingType ? (
            <Dimmer active inverted>
                <Loader>Please Wait...</Loader>
            </Dimmer>
        ) : (
            <Container fluid>
                <Row className="mt-1 mb-3">
                    <div className="text-facebook h3 mb-0">Invoice</div>
                    <div className="text-muted">This is invoice for order #{location.state.id_order}</div>
                </Row>
                <Divider />
                <Row className="mb-3">
                    <Col lg={6}>

                    </Col>
                    <Col lg={6} className='d-flex justify-content-end'>
                        <Button content="Print" icon="print" onClick={handlePrint} />
                    </Col>
                </Row>
                {
                    order && !warehouseDetailLoader && !resiDataLoader ?
                        <PrintComponent ref={componentRef} data={order} />
                        : <>Loading...</>
                }
            </Container>
        )
    )
}

export default OrderInvoice